import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import { reduxForm, Field } from 'redux-form';

import CheckboxButtonField from 'components/fields/CheckboxButtonField';
import IconArrowTop from 'components/icons/IconArrowTop';
import IconArrowBottom from 'components/icons/IconArrowBottom';

const styles = theme => ({
  iconArrow: {
    width: 10,
    height: 10,
    marginRight: 10,
  },
  iconIncome: {
    color: theme.palette.add[500],
  },
  iconReturn: {
    color: theme.palette.notification[500],
  },
  iconSold: {
    color: theme.palette.validation[500],
  },
  typography: {
    textTransform: 'uppercase',
    marginRight: 20,
  },
});

function onChange(values, dispatch, props, previousValues) {
  if (values.All === true) {
    if (!previousValues.All) {
      if (values.Incoming === true) {
        dispatch(props.change('Incoming', false));
      }
      if (values.Sale === true) {
        dispatch(props.change('Sale', false));
      }
      if (values.Returns === true) {
        dispatch(props.change('Returns', false));
      }
    }
    if ((values.Incoming === true && !previousValues.Incoming)
    || (values.Sale === true && !previousValues.Sale)
    || (values.Returns === true && !previousValues.Returns)) {
      dispatch(props.change('All', false));
    }
  }
}

const InventoryStockLineHistoryViewFilter = ({
  handleSubmit, className, title, classes,
}) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Toolbar disableGutters>
      {title.length > 0 &&
        <Typography
          color="secondary"
          className={classes.typography}
        >
          {title}
        </Typography>
      }
      <Field
        id="All"
        name="All"
        label="All"
        component={CheckboxButtonField}
      />
      <Field
        id="Incoming"
        name="Incoming"
        label="Stock In"
        icon={(
          <IconArrowTop className={classNames(classes.iconArrow, classes.iconIncome)} />
        )}
        component={CheckboxButtonField}
      />
      <Field
        id="Sale"
        name="Sale"
        label="Sold"
        icon={(
          <IconArrowBottom className={classNames(classes.iconArrow, classes.iconSold)} />
        )}
        component={CheckboxButtonField}
      />
      <Field
        id="Returns"
        name="Returns"
        label="Return"
        icon={(
          <IconArrowTop className={classNames(classes.iconArrow, classes.iconReturn)} />
        )}
        component={CheckboxButtonField}
      />
    </Toolbar>
  </form>
);

InventoryStockLineHistoryViewFilter.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  classes: PropTypes.shape({
    iconArrow: PropTypes.string.isRequired,
    iconIncome: PropTypes.string.isRequired,
    iconReturn: PropTypes.string.isRequired,
    iconSold: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryStockLineHistoryViewFilter.defaultProps = {
  className: '',
  title: '',
};

export default reduxForm({
  onChange,
  initialValues: {
    All: true,
  },
})(withStyles(styles)(InventoryStockLineHistoryViewFilter));



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryStockLineHistoryViewDialog/InventoryStockLineHistoryViewFilter.js